import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@querodelivery/uni-react';
import { faChevronUp, faUp } from '@fortawesome/pro-solid-svg-icons';
import { MONITOR_BACK_TO_TOP_OFFSET } from '../../constants';
import styles from './back-to-top.module.scss';

export function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setIsVisible(window.scrollY > MONITOR_BACK_TO_TOP_OFFSET);
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="primary"
      size="md"
      className={styles.button}
      icon={<FontAwesomeIcon icon={faUp} />}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      Voltar ao topo
    </Button>
  );
}
